import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './i18n';
import { App } from './App.tsx';
import { initTheme } from './features/theme/theme';

// Slice 23 — start the live `auto` follow. First paint was already set by the
// inline pre-paint script in index.html; this only wires the OS-preference
// listener so an `auto` staff member's portal follows dusk without a reload.
initTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
